import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';

// ====================================
// BodyCopy
// ================

const Markdown = (props) => {
  const { children } = props;
  return (
    <>
      <ReactMarkdown
        escapeHtml
        source={children}
        disallowedTypes={['html', 'virtualHtml', 'parsedHtml']}
      />
    </>
  );
};

export default Markdown;
